import Axios from 'axios';

import { removeClient, updateClientStatus } from '../../AddClient/actions';

// eslint-disable-next-line
export const deleteClient = ({authToken, client}) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    Axios
        .delete(`v1/customer/${client.id}`, optionAxios)
        .then(() => {
            dispatch(removeClient(client.id));
            dispatch(updateClientStatus('Successfully Deleted Client'));
        }).catch(() => {
        });
};



// WEBPACK FOOTER //
// ./src/containers/ClientsList/ClientSummary/actions.js